import { defineComponent, h } from '@vue/composition-api';
export var DarkArrowUp = defineComponent({
  setup: function setup() {
    return function () {
      return h("svg", {
        "attrs": {
          "width": "24",
          "height": "8",
          "viewBox": "0 0 24 8",
          "fill": "currentColor",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "clip-path": "url(#clip0_400_462)"
        }
      }, [h("path", {
        "attrs": {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M14.9855 1.49673C13.388 -0.269431 10.6119 -0.269561 9.01435 1.49656C7.3253 3.36386 5.39192 5.48621 4.57494 6.32755C2.98268 7.96729 6.99382e-07 8 6.99382e-07 8L24 8C24 8 21.035 7.98547 19.4268 6.32937C18.6025 5.48043 16.6717 3.36102 14.9855 1.49673Z",
          "fill": "currentColor",
          "fill-opacity": "0.72"
        }
      })]), h("defs", [h("clipPath", {
        "attrs": {
          "id": "clip0_400_462"
        }
      }, [h("rect", {
        "attrs": {
          "width": "24",
          "height": "8",
          "fill": "currentColor",
          "transform": "translate(24 8) rotate(180)"
        }
      })])])]);
    };
  }
});
export var DarkArrowDown = defineComponent({
  setup: function setup() {
    return function () {
      return h("svg", {
        "attrs": {
          "width": "24",
          "height": "8",
          "viewBox": "0 0 24 8",
          "fill": "currentColor",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "clip-path": "url(#clip0_400_461)"
        }
      }, [h("path", {
        "attrs": {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M9.01453 6.50327C10.612 8.26943 13.3881 8.26956 14.9857 6.50344C16.6747 4.63614 18.6081 2.5138 19.4251 1.67245C21.0173 0.0327168 24 1.90735e-06 24 1.90735e-06H0C0 1.90735e-06 2.96502 0.0145273 4.57317 1.67063C5.39753 2.51957 7.32829 4.63898 9.01453 6.50327Z",
          "fill": "currentColor",
          "fill-opacity": "0.72"
        }
      })]), h("defs", [h("clipPath", {
        "attrs": {
          "id": "clip0_400_461"
        }
      }, [h("rect", {
        "attrs": {
          "width": "24",
          "height": "8",
          "fill": "currentColor"
        }
      })])])]);
    };
  }
});
export var DarkArrowLeft = defineComponent({
  setup: function setup() {
    return function () {
      return h("svg", {
        "attrs": {
          "width": "8",
          "height": "24",
          "viewBox": "0 0 8 24",
          "fill": "currentColor",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "clip-path": "url(#clip0_400_463)"
        }
      }, [h("path", {
        "attrs": {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M1.49708 9.01453C-0.269084 10.612 -0.269214 13.3881 1.49691 14.9857C3.36421 16.6747 5.48655 18.6081 6.3279 19.4251C7.96763 21.0173 8.00035 24 8.00035 24L8.00035 4.29147e-07C8.00035 4.29147e-07 7.98582 2.96502 6.32972 4.57317C5.48078 5.39753 3.36137 7.32829 1.49708 9.01453Z",
          "fill": "currentColor",
          "fill-opacity": "0.72"
        }
      })]), h("defs", [h("clipPath", {
        "attrs": {
          "id": "clip0_400_463"
        }
      }, [h("rect", {
        "attrs": {
          "width": "24",
          "height": "8",
          "fill": "currentColor",
          "transform": "translate(8) rotate(90)"
        }
      })])])]);
    };
  }
});
export var DarkArrowRight = defineComponent({
  setup: function setup() {
    return function () {
      return h("svg", {
        "attrs": {
          "width": "8",
          "height": "24",
          "viewBox": "0 0 8 24",
          "fill": "currentColor",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "clip-path": "url(#clip0_400_464)"
        }
      }, [h("path", {
        "attrs": {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M6.50327 14.9855C8.26943 13.388 8.26956 10.6119 6.50344 9.01435C4.63614 7.3253 2.51379 5.39192 1.67245 4.57494C0.032713 2.98268 -1.04907e-06 3.49691e-07 -1.04907e-06 3.49691e-07L0 24C0 24 0.0145253 21.035 1.67063 19.4268C2.51957 18.6025 4.63898 16.6717 6.50327 14.9855Z",
          "fill": "currentColor",
          "fill-opacity": "0.72"
        }
      })]), h("defs", [h("clipPath", {
        "attrs": {
          "id": "clip0_400_464"
        }
      }, [h("rect", {
        "attrs": {
          "width": "24",
          "height": "8",
          "fill": "currentColor",
          "transform": "translate(0 24) rotate(-90)"
        }
      })])])]);
    };
  }
});
export var LightArrowUp = defineComponent({
  setup: function setup() {
    return function () {
      return h("svg", {
        "attrs": {
          "width": "24",
          "height": "8",
          "viewBox": "0 0 24 8",
          "fill": "currentColor",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "clip-path": "url(#clip0_399_433)"
        }
      }, [h("path", {
        "attrs": {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M14.9855 1.49673C13.388 -0.269431 10.6119 -0.269561 9.01435 1.49656C7.3253 3.36386 5.39192 5.48621 4.57494 6.32755C2.98268 7.96729 6.99382e-07 8 6.99382e-07 8L24 8C24 8 21.035 7.98547 19.4268 6.32937C18.6025 5.48043 16.6717 3.36102 14.9855 1.49673Z",
          "fill": "currentColor"
        }
      })]), h("defs", [h("clipPath", {
        "attrs": {
          "id": "clip0_399_433"
        }
      }, [h("rect", {
        "attrs": {
          "width": "24",
          "height": "8",
          "fill": "currentColor",
          "transform": "translate(24 8) rotate(180)"
        }
      })])])]);
    };
  }
});
export var LightArrowDown = defineComponent({
  setup: function setup() {
    return function () {
      return h("svg", {
        "attrs": {
          "width": "24",
          "height": "8",
          "viewBox": "0 0 24 8",
          "fill": "currentColor",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "clip-path": "url(#clip0_396_423)"
        }
      }, [h("path", {
        "attrs": {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M9.01453 6.50327C10.612 8.26943 13.3881 8.26956 14.9857 6.50344C16.6747 4.63614 18.6081 2.5138 19.4251 1.67245C21.0173 0.0327168 24 1.90735e-06 24 1.90735e-06H0C0 1.90735e-06 2.96502 0.0145273 4.57317 1.67063C5.39753 2.51957 7.32829 4.63898 9.01453 6.50327Z",
          "fill": "currentColor"
        }
      })]), h("defs", [h("clipPath", {
        "attrs": {
          "id": "clip0_396_423"
        }
      }, [h("rect", {
        "attrs": {
          "width": "24",
          "height": "8",
          "fill": "currentColor"
        }
      })])])]);
    };
  }
});
export var LightArrowLeft = defineComponent({
  setup: function setup() {
    return function () {
      return h("svg", {
        "attrs": {
          "width": "8",
          "height": "24",
          "viewBox": "0 0 8 24",
          "fill": "currentColor",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "clip-path": "url(#clip0_399_442)"
        }
      }, [h("path", {
        "attrs": {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M1.49673 9.01453C-0.269432 10.612 -0.269563 13.3881 1.49656 14.9857C3.36386 16.6747 5.48621 18.6081 6.32755 19.4251C7.96729 21.0173 8 24 8 24L8 3.49691e-07C8 3.49691e-07 7.98547 2.96502 6.32937 4.57317C5.48043 5.39753 3.36102 7.32829 1.49673 9.01453Z",
          "fill": "currentColor"
        }
      })]), h("defs", [h("clipPath", {
        "attrs": {
          "id": "clip0_399_442"
        }
      }, [h("rect", {
        "attrs": {
          "width": "24",
          "height": "8",
          "fill": "currentColor",
          "transform": "translate(8) rotate(90)"
        }
      })])])]);
    };
  }
});
export var LightArrowRight = defineComponent({
  setup: function setup() {
    return function () {
      return h("svg", {
        "attrs": {
          "width": "8",
          "height": "24",
          "viewBox": "0 0 8 24",
          "fill": "currentColor",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "clip-path": "url(#clip0_399_443)"
        }
      }, [h("path", {
        "attrs": {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M6.50327 14.9855C8.26943 13.388 8.26956 10.6119 6.50344 9.01435C4.63614 7.3253 2.51379 5.39192 1.67245 4.57494C0.032713 2.98268 -1.04907e-06 3.49691e-07 -1.04907e-06 3.49691e-07L0 24C0 24 0.0145253 21.035 1.67063 19.4268C2.51957 18.6025 4.63898 16.6717 6.50327 14.9855Z",
          "fill": "currentColor"
        }
      })]), h("defs", [h("clipPath", {
        "attrs": {
          "id": "clip0_399_443"
        }
      }, [h("rect", {
        "attrs": {
          "width": "24",
          "height": "8",
          "fill": "currentColor",
          "transform": "translate(0 24) rotate(-90)"
        }
      })])])]);
    };
  }
});